export const DATA_LAYER_EVENT_REGISTRATION_COMPLETE = 'registration_complete';
export const DATA_LAYER_EVENT_START_TRIAL = 'start_trial';
